module.exports = __webpack_public_path__ + "img/VectorremovePerson.622b11d1.svg";